import React from 'react';
import LicensingContext from './LicensingContext';
/** @returns {import('./types').LicenseProviderProps} */

var useLicense = function useLicense() {
  var context = React.useContext(LicensingContext);
  return context;
};

export default useLicense;